import { render, staticRenderFns } from "./SupplierPerformanceTable.vue?vue&type=template&id=73aed4de&scoped=true"
import script from "./SupplierPerformanceTable.vue?vue&type=script&lang=js"
export * from "./SupplierPerformanceTable.vue?vue&type=script&lang=js"
import style0 from "./SupplierPerformanceTable.vue?vue&type=style&index=0&id=73aed4de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73aed4de",
  null
  
)

export default component.exports